export interface AppConfig {
  rootEl: HTMLElement;
  assetBaseUrl: string;
  entryExternalId?: string;
  proxyApiUrl: string;
  role: string;
  sessionExpirationRedirectUrl: string;
  userName: string;
  workflowReturnUrl?: string;
  workflowCompletionSynchronousUrl?: string;
  workflowCompletionSynchronousErrorMessage?: string;
  workflowSuspensionSynchronousUrl?: string;
  workflowSuspensionSynchronousErrorMessage?: string;
  imageSizeLimitinMB: number;
  attachmentSizeLimitInMB: number;
  userId: string;
  authToken?: string;
  supportedImageMimeTypes: [];
  supportedImageFileExt: [];
  supportedAttachmentMimeTypes: [];
  supportedAttachmentsFileExt: [];
}

const rootEl = document.getElementById('root') as HTMLElement;
const serializedConfig = rootEl.dataset.configuration as string;
const deserializedConfig = JSON.parse(serializedConfig);
const config: AppConfig = {
  rootEl,
  imageSizeLimitinMB: 5,
  attachmentSizeLimitInMB: 10,
  supportedImageMimeTypes: [
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/svg+xml'
  ],
  supportedImageFileExt: [
    'gif',
    'jpg',
    'jpeg',
    'pjp',
    'pjpeg',
    'jfif',
    'png',
    'svg',
    'svgz'
  ],
  supportedAttachmentMimeTypes: [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/pdf'
  ],
  supportedAttachmentsFileExt: [
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'pdf'
  ],
  ...deserializedConfig
};

// cleanup data from memory
delete rootEl.dataset.configuration;

// clenaup data from DOM
rootEl.removeAttribute('data-configuration');

export default config;
